import {
  Component,
  EventEmitter,
  isDevMode,
  OnInit,
  Output,
  ChangeDetectionStrategy
} from "@angular/core";
import { Observable, throwError as observableThrowError } from "rxjs";

import { Share } from "../_model/share";

import { StoreService } from "../_service/store.service";
import { HelperService } from "../_service/helper.service";
import { APIService } from "../_service/api.service";
import { AffiliateService } from "../_service/affiliate.service";
import { ISGService } from "../_service/isg.service";

import { AnalyticsEvent } from "../_model/analytics-event";
import { ISGObject } from "../_model/isg-object";

@Component({
    selector: "result",
    templateUrl: "result.component.html",
    styleUrls: ["result.component.css"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ResultComponent implements OnInit {
  ping: number;
  download: number;
  upload: number;
  ip: string;
  ipv4: string;
  ipv6: string;
  isp: string;
  downloadedData: string;
  uploadedData: string;
  downloadFluctuation: number;
  uploadFluctuation: number;

  // private shareButtons: ShareButtons = new ShareButtons()
  shareButtons: Share[];

  shareUrl = "https://www.speedcheck.org/result/1";
  shareTitle = "My Speedcheck Result";
  shareDescription = "Beschreibung";
  shareImageUrl =
    "https://lh3.googleusercontent.com/umgB610js1v1PqbxxoeMcGESnOL5KCXbhedt6d1T_f5Gyq2ibY1hSSYy_CAtR-8j5g=h900";
  shareTagsString = "internet,speed,test";

  isAndroid: Boolean = true;
  isMobile: Boolean = false;

  downloadHistogram: number[];
  downloadHistogramToPlot: number[];
  uploadHistogram: number[];
  uploadHistogramToPlot: number[];
  downloadStability: string;
  uploadStability: string;

  routers: Object[];

  adItem: Object = {
    imageUrl:
      "//ws-eu.amazon-adsystem.com/widgets/q?_encoding=UTF8&MarketPlace=DE&ASIN=B00PVDTRL4&ServiceVersion=20070822&ID=AsinImage&WS=1&Format=_SL160_",
    link: "https://www.amazon.de/gp/product/B00PVDTRL4/ref=as_li_tl?ie=UTF8&camp=1638&creative=6742&creativeASIN=B00PVDTRL4&linkCode=as2&linkId=ae776659f22bc0df43fe1e104128c90b",
    text: "D-Link DIR-842 Wireless Gigabit Router (WLAN-Geschwindigkeiten bis zu 1200 Mbit/s, AC1200 Dual Band)",
  };

  isgObject: ISGObject;

  position: any = {};
  offerConfig: any = undefined;

  set DownloadHistogram(status: number[]) {
    this.downloadHistogram = status;
    this.downloadHistogramToPlot = this.downloadHistogram.slice(0, 60);
  }

  set UploadHistogram(status: number[]) {
    this.uploadHistogram = status;
    this.uploadHistogramToPlot = this.uploadHistogram.slice(0, 60);
  }

  getInitialHistogramStatus() {
    return [];
  }

  @Output() notify: EventEmitter<string> = new EventEmitter<string>();

  constructor(
    private storeService: StoreService,
    private helperService: HelperService,
    private apiService: APIService,
    private affiliateService: AffiliateService,
    private isgService: ISGService
  ) {}

  ngOnInit() {
    this.isp = this.storeService.ispName;
    this.ip = this.storeService.test.ip;
    this.ping = this.storeService.test.ping;
    this.download = this.storeService.test.download;
    this.upload = this.storeService.test.upload;
    this.ipv4 = this.storeService.test.ip;
    this.ipv6 = this.storeService.test.ipv6;
    this.downloadedData = this.formatBytes(
      this.storeService.test.downloadedData,
      0
    );
    this.uploadedData = this.formatBytes(
      this.storeService.test.uploadedData,
      0
    );
    if (this.storeService.test.downloadStability) {
      this.downloadStability =
        this.storeService.test.downloadStability.toFixed(0) + "%";
    }
    if (this.storeService.test.uploadStability) {
      this.uploadStability =
        this.storeService.test.uploadStability.toFixed(0) + "%";
    }

    this.setupShareButtons();
    if (this.helperService.isMobileOperatingSystem()) {
      this.isMobile = true;
    }
    if (this.helperService.getMobileOperatingSystem() == "iOS") {
      this.isAndroid = false;
    }

    this.DownloadHistogram = this.getInitialHistogramStatus();
    this.UploadHistogram = this.getInitialHistogramStatus();

    const dh = this.storeService.test.downloadHistogram;
    if (dh !== undefined) {
      // console.log(dh)
      this.DownloadHistogram = dh;
    }
    const uh = this.storeService.test.uploadHistogram;
    if (dh !== undefined) {
      // console.log(uh)
      this.UploadHistogram = uh;
    }

    // AWS Affiliate
    // this.affiliateService.postRouters(this.storeService.isp)
    //                     .subscribe(result => {
    //                         this.routers = result;
    //                     },
    //                     error => console.log());

    // ISG
    this.offerConfig = this.storeService.isgOffer;
  }

  devOptions() {
    // this.DownloadHistogram = [290.9596252441406, 464.591142134233, 542.0276697469552, 472.02326270377284, 468.8253846417367, 504.3548321856557, 486.33657771391074, 485.8137176789062, 507.1757274159002, 455.66507947562945, 472.05401780861575, 493.88552180803555, 494.62338513667015, 356.7218065644324, 601.3992291115223, 496.04651836735184, 349.06655536311746, 562.0239440029113, 486.1750288287404, 389.58879267127804, 579.1327766418462, 495.2204438781733, 397.1809286499024, 567.4846827189126, 471.2065277351403, 414.4984715527831, 521.7233287956151, 497.1633252405045, 435.40111146681016, 529.3356741573034, 477.93627103312525, 434.3730285644543, 530.0383245849607, 510.7190257701305, 442.4017988148308, 491.28037396599393, 505.0489702741816, 449.37824548150365, 487.7876773609851, 501.1666549144066, 461.4676752178939, 480.1139966619412, 496.77709477490686, 493.96669186555846, 422.5771818363865, 494.00939453923274, 488.20093714151704, 485.32593315682067, 496.4329285821632, 484.54513490159206, 450.895978099331, 515.4873760986303, 427.8556567382839, 488.10490943645345, 535.6827416255583, 423.37511444091797, 412.87500000000006, 0, 0, 0]
    // this.UploadHistogram = [56.197163508488586, 52.55283649151142, 37.29950495049505, 53.30398541857824, 51.89650963092672, 57.67499999999998, 37.59170837402346, 48.73329162597657, 55.19554455445544, 37.48998066290847, 54.314474782636104, 50.58415841584156, 38.292799404170495, 53.62304217998795, 53.22029702970301, 36.482636903720994, 55.047066066576015, 49.88613861386137, 34.90556365664645, 59.20829772949219, 48.75742574257419, 44.63449419249753, 53.40508499125093, 46.25299507367743, 44.36466243092593, 52.57541301094438, 40.28265183085682, 48.576698996804055, 54.00054931640625, 44.44705411703279, 46.72680888519938, 50.501140659877194, 48.38752075195328, 44.634038596929265, 38.99305388160542, 58.37790752146509, 45.596895878233, 54.10686647383228, 44.94873764793499, 44.138818037431065, 52.124491360546585, 40.20669060202204, 52.052130962171084, 51.457844623766505, 48.87649500229793, 44.34906328253953, 49.44226313475588, 49.56220299446921, 47.6450207519531, 47.11245300292979, 49.39252624511699, 42.82122070312517, 48.108755493163926, 49.11774657598835, 24.17275330194161, 74.32722192141092, 11.772302004370204, 0, 0, 0]
  }

  setupShareButtons() {
    const buttonSize = -4;

    const testId: number = this.storeService.test.id;
    // let testId: number = 1
    const baseUrl = "https://www.speedcheck.org/result/";
    const shareUrl: string = baseUrl + testId;

    const shareTitle = "My Speedcheck Result";
    const shareDescription =
      "Can you beat my internet speed? This is my Speedcheck result.";
    const shareTagsString = "internet,speed,test";
    // let shareImageUrl = "https://image.speedcheck.org/" + testId + ".png"
    const shareImageUrl = "https://image.speedcheck.org/1.png";

    const facebook = new Share();
    facebook.shareButton = "facebook";
    facebook.shareSize = buttonSize;

    facebook.shareUrl = shareUrl;
    facebook.shareTitle = shareTitle;
    facebook.shareDescription = shareDescription;
    facebook.shareImageUrl = shareImageUrl;
    facebook.shareTagsString = shareTagsString;

    const twitter = new Share();
    twitter.shareButton = "twitter";
    twitter.shareSize = buttonSize;
    twitter.shareUrl = shareUrl;
    twitter.shareTitle = shareTitle;
    twitter.shareDescription = shareDescription;
    twitter.shareImageUrl = shareImageUrl;
    twitter.shareTagsString = shareTagsString;

    const linkedin = new Share();
    linkedin.shareButton = "linkedin";
    linkedin.shareSize = buttonSize;
    linkedin.shareUrl = shareUrl;
    linkedin.shareTitle = shareTitle;
    linkedin.shareDescription = shareDescription;
    linkedin.shareImageUrl = shareImageUrl;
    linkedin.shareTagsString = shareTagsString;

    const email = new Share();
    email.shareButton = "email";
    email.shareSize = buttonSize;
    email.shareUrl = shareUrl;
    email.shareTitle = shareTitle;
    email.shareDescription = shareDescription;
    email.shareImageUrl = shareImageUrl;
    email.shareTagsString = shareTagsString;

    const copy = new Share();
    copy.shareButton = "copy";
    copy.shareSize = buttonSize;
    copy.shareUrl = shareUrl;
    copy.shareTitle = shareTitle;
    copy.shareDescription = shareDescription;
    copy.shareImageUrl = shareImageUrl;
    copy.shareTagsString = shareTagsString;

    const whatsapp = new Share();
    whatsapp.shareButton = "whatsapp";
    whatsapp.shareSize = buttonSize;
    whatsapp.shareUrl = shareUrl;
    whatsapp.shareTitle = shareTitle;
    whatsapp.shareDescription = shareDescription;
    whatsapp.shareImageUrl = shareImageUrl;
    whatsapp.shareTagsString = shareTagsString;

    const google = new Share();
    google.shareButton = "google";
    google.shareSize = buttonSize;
    google.shareUrl = shareUrl;
    google.shareTitle = shareTitle;
    google.shareDescription = shareDescription;
    google.shareImageUrl = shareImageUrl;
    google.shareTagsString = shareTagsString;

    const tumblr = new Share();
    tumblr.shareButton = "tumblr";
    tumblr.shareSize = buttonSize;
    tumblr.shareUrl = shareUrl;
    tumblr.shareTitle = shareTitle;
    tumblr.shareDescription = shareDescription;
    tumblr.shareImageUrl = shareImageUrl;
    tumblr.shareTagsString = shareTagsString;

    const reddit = new Share();
    reddit.shareButton = "reddit";
    reddit.shareSize = buttonSize;
    reddit.shareUrl = shareUrl;
    reddit.shareTitle = shareTitle;
    reddit.shareDescription = shareDescription;
    reddit.shareImageUrl = shareImageUrl;
    reddit.shareTagsString = shareTagsString;

    const pinterest = new Share();
    pinterest.shareButton = "pinterest";
    pinterest.shareSize = buttonSize;
    pinterest.shareUrl = shareUrl;
    pinterest.shareTitle = shareTitle;
    pinterest.shareDescription = shareDescription;
    pinterest.shareImageUrl = shareImageUrl;
    pinterest.shareTagsString = shareTagsString;

    this.shareButtons = [
      facebook,
      twitter,
      linkedin,
      email,
      copy,
      whatsapp,
      google,
      tumblr,
      reddit,
      pinterest,
    ];
  }

  onRestart(event: any) {
    this.notify.emit("restart");
  }

  showLink() {
    // console.log('showLink')
  }

  showFacebook() {
    // console.log('showFacebook')
  }

  showTwitter() {
    // console.log('showTwitter')
  }

  storeClick() {
    const object: AnalyticsEvent = new AnalyticsEvent();
    object.name = "result-page-app-store-click";
    object.source = "w-sc-1";
    if (isDevMode()) {
      object.source = "w-sc-1-dev";
    }
    object.os = "Web";
    object.parameters = {
      os: this.helperService.getMobileOperatingSystem(),
    };

    this.apiService.saveEvent(object).subscribe(
      (result) => {},
      (error) => console.log()
    );

    if (this.isAndroid) {
      window.location.href =
        "https://play.google.com/store/apps/details?id=org.speedcheck.internet.speed.test";
    } else {
      window.location.href = "https://itunes.apple.com/app/id616145031";
    }
  }

  formatBytes(bytes, decimals) {
    if (bytes == 0) {
      return "0 Bytes";
    }
    const k = 1024,
      dm = decimals || 2,
      sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
      i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  }
}
